export enum ReactionsListColumns {
  NAME = 'Name',
  PASS_MESSAGE = 'Message On Pass',
  ACTIONS = 'Actions',
}
